import { FC } from "react"
import { Helmet } from "react-helmet-async"

type SEOProps = {
  title?: string
  description?: string
}

const SEO: FC<SEOProps> = ({ title, description }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
    </Helmet>
  )
}

export default SEO
